import GET_CHARACTER from "./getCharacter"
import GET_CHARACTERS from "./getCharacters"

export default {
  GET_CHARACTER,
  GET_CHARACTERS
}
